<div class="risk-detail-panel card border-top-0 mb-3">
  <div class="card-body p-4">
    @if (riskCheck().linked_case_count > 0) {
      <div class="mb-4">
        <h6 class="fw-semibold mb-2">Impact</h6>
        <div class="alert alert-warning py-2 mb-0">
          <p class="mb-1">In the last 30 days:</p>
          <ul class="mb-0">
            <li>
              <strong>{{ riskCheck().linked_case_count }}</strong>
              case{{ riskCheck().linked_case_count === 1 ? '' : 's' }} linked to this risk
            </li>
            <li>
              {{ riskCheck().linked_case_count === 1 ? 'This represents' : 'These represent' }}
              <strong>{{ riskCheck().impact_percentage }}%</strong> of your identity incidents
            </li>
          </ul>
        </div>
      </div>
    }

    <!-- Interactive controls (accept/reopen, the affected-users table) only when the check has
         something to act on. A passing check (empty table, nothing to accept) and a not-evaluated
         one are both read-only; Why This Matters, current settings and the footer still render. -->
    @if (!readOnly() && isTenantScope()) {
      <!-- Tenant-wide config check: single check-level accept, no entity table -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="fw-semibold mb-0">
          Tenant-wide setting
          @if (tenantAccepted()) {
            <span class="severity-badge severity-neutral ms-1">Risk accepted</span>
          }
        </h6>
        @if (tenantAccepted()) {
          <button
            class="btn btn-outline-danger btn-sm"
            (click)="onReopenCheck(); $event.stopPropagation()"
          >
            Reopen
          </button>
        } @else {
          <button
            class="btn btn-outline-secondary btn-sm"
            (click)="onAcceptCheck(); $event.stopPropagation()"
          >
            Accept Risk
          </button>
        }
      </div>
      @if (tenantAccepted() && tenantReason()) {
        <p class="text-muted small mb-4">
          <span class="fw-medium">Acceptance note:</span> {{ tenantReason() }}
        </p>
      } @else {
        <div class="mb-4"></div>
      }
    } @else if (!readOnly()) {
      <!-- Entity-scoped check: per-entity accept + bulk accept -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h6 class="fw-semibold mb-0">
          Affected Users
          <span class="severity-badge severity-neutral ms-1">{{ acceptedCount() }} / {{ totalCount() }} accepted</span>
        </h6>
        @if (openCount() > 0) {
          <button
            class="btn btn-outline-secondary btn-sm"
            (click)="onAcceptAll(); $event.stopPropagation()"
          >
            Accept All ({{ openCount() }})
          </button>
        }
      </div>
      <div class="mb-4">
        <app-datatable
          [data-href]="usersUrl()"
          [columns]="userColumns"
          [successCallback]="onUsersLoaded"
        ></app-datatable>
      </div>
    }

    <!-- Current Settings (aggregate, non-sensitive config snapshot). Hidden for a not-evaluated
         check: there is no readable configuration to snapshot. -->
    @if (!notEvaluated() && currentSettings().length) {
      <div class="mb-3">
        <h6 class="fw-semibold mb-2">Current settings</h6>
        <dl class="row mb-0 small">
          @for (setting of currentSettings(); track setting.label) {
            <dt class="col-sm-4 text-muted fw-medium">{{ setting.label }}</dt>
            <dd class="col-sm-8 mb-1">{{ setting.value }}</dd>
          }
        </dl>
      </div>
    }

    <!-- Explanation Section -->
    <div class="mb-3">
      <h6 class="fw-semibold mb-2">Why This Matters</h6>
      <p class="text-muted mb-0">{{ riskCheck().explanation }}</p>
    </div>

    <!-- Detection Type (1:1 mapping for MVP) -->
    @if (riskCheck().detection_type) {
      <div class="pt-3 border-top">
        <span class="text-muted small me-2">Mapped detection type:</span>
        <span class="badge bg-light text-dark border">{{ riskCheck().detection_type }}</span>
      </div>
    }
  </div>
</div>

@if (acceptTarget()) {
  <app-accept-reason-dialog
    [title]="acceptDialogTitle()"
    (cancel)="onAcceptCancel()"
    (confirm)="onAcceptConfirm($event)"
  ></app-accept-reason-dialog>
}
